import * as SliderPrimitive from "@radix-ui/react-slider";
import { ComponentPropsWithoutRef, ComponentRef, forwardRef } from "react";

export const Slider = forwardRef<
  ComponentRef<typeof SliderPrimitive.Root>,
  ComponentPropsWithoutRef<typeof SliderPrimitive.Root> & {
    thumbLabel: string;
  }
>(({ className, thumbLabel, ...props }, ref) => (
  <form>
    <SliderPrimitive.Root
      {...props}
      ref={ref}
      className={`relative ${className}`}
    >
      <SliderPrimitive.Track className="relative block h-2 w-full rounded-lg border border-neutral-500 bg-white">
        <SliderPrimitive.Range className="bg-primary absolute block h-full rounded-lg" />
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb
        className="focus:border-darkGrey focus:outline-hidden absolute -top-3 block h-4 w-4 translate-x-[-50%] cursor-pointer rounded-full border border-neutral-500 bg-white ring-neutral-500 focus:border-2"
        aria-label={thumbLabel}
      >
        <span className="bg-primary absolute left-1/2 top-1/2 block h-1 w-1 translate-x-[-50%] translate-y-[-50%] rounded-full border"></span>
      </SliderPrimitive.Thumb>
    </SliderPrimitive.Root>
  </form>
));

Slider.displayName = "Slider";
